import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentSection, Fieldset, Layout, Modal } from '@vwfs-bronson/bronson-react';
import { VehicleType } from '../../resources/base/models/vehicleTypes';

interface Props {
  visible: boolean;
  onCancel: any;
  onConfirm: any;
  vehicleType?: VehicleType;
}

export const DemoCarErrorModal: FunctionComponent<Props> = (props) => {
  const { t } = useTranslation();
  const { visible, onCancel, onConfirm, vehicleType } = props;

  return (
    <Modal
      id="demoCarErrorModal"
      title={t('step1:configVehicle:demoCarErrorModal:continueButtonStockCar')}
      hideTitle
      buttonConfirmText={
        vehicleType === VehicleType.USED
          ? t('step1:configVehicle:demoCarErrorModal:continueButtonUsedCar')
          : t('step1:configVehicle:demoCarErrorModal:continueButtonStockCar')
      }
      buttonCancelText={t('step1:configVehicle:demoCarErrorModal:backButton')}
      shown={visible}
      onClose={() => onCancel()}
      onCancel={() => {
        onCancel();
      }}
      onConfirm={() => {
        onConfirm();
      }}
      asPortal
    >
      <ContentSection pageWrap>
        <Fieldset>
          <Layout>
            <Fieldset.Row>
              <Layout.Item default="1/1" className="u-text-center u-mv-none">
                {(() => {
                  switch (vehicleType) {
                    case VehicleType.USED:
                      return t('step1:configVehicle:demoCarErrorModal:usedCarText');
                    case VehicleType.NEW:
                      return t('step1:configVehicle:demoCarErrorModal:newCarText');
                    case VehicleType.STOCK:
                    default:
                      return t('step1:configVehicle:demoCarErrorModal:stockCarText');
                  }
                })()}
              </Layout.Item>
            </Fieldset.Row>
          </Layout>
        </Fieldset>
      </ContentSection>
    </Modal>
  );
};
